import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValue } from 'customer-data-objects/objects/ObjectAccessors';
import get from 'transmute/get';
import { jsx as _jsx } from "react/jsx-runtime";
// Intentionally untyped since incoming values are not typed
const VALID_PRIORITIES = new Set(['urgent', 'high', 'medium', 'low']);
const valueIsPriority = value => VALID_PRIORITIES.has(value);
const getPriorityValue = data => {
  const priority = getPropertyValue(data, 'hs_priority') || getPropertyValue(data, 'hs_ticket_priority');
  if (!priority) {
    return undefined;
  }
  const priorityValue = get('value', priority);
  if (!priorityValue || typeof priorityValue !== 'string') {
    return undefined;
  }
  const lowercasePriority = priorityValue.toLowerCase();
  if (!valueIsPriority(lowercasePriority)) {
    return undefined;
  }
  return lowercasePriority;
};
const getLabelAndColorFromPriority = priorityValue => {
  switch (priorityValue) {
    case 'urgent':
      return {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-data-board-card.priorityLabel.urgent"
        }),
        color: 'fill-accent-red-default'
      };
    case 'high':
      return {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-data-board-card.priorityLabel.high"
        }),
        color: 'fill-accent-orange-default'
      };
    case 'medium':
      return {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-data-board-card.priorityLabel.medium"
        }),
        color: 'fill-accent-yellow-default'
      };
    case 'low':
      return {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-data-board-card.priorityLabel.low"
        }),
        color: 'fill-accent-green-default'
      };
    default:
      return {
        label: null,
        color: 'fill-primary-disabled' // a default case that should rarely get hit.
      };
  }
};
const PriorityBadge = ({
  subject
}) => {
  const priorityValue = getPriorityValue(subject);
  if (!priorityValue) {
    return null;
  }
  const {
    label,
    color
  } = getLabelAndColorFromPriority(priorityValue);
  return /*#__PURE__*/_jsx(StatusTag, {
    color: color,
    "data-selenium-info": priorityValue,
    "data-test-id": "cdbc-priority",
    children: label
  });
};
export default PriorityBadge;